"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.operationTypes = exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _jsTools = require("@airportlabs/js-tools");
var _client = require("@apollo/client");
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _differenceBy = _interopRequireDefault(require("lodash/differenceBy"));
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _findKey = _interopRequireDefault(require("lodash/findKey"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _react = require("react");
var _useDebouncedOperation = _interopRequireDefault(require("./useDebouncedOperation"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var operationTypes = exports.operationTypes = {
  READY: "READY",
  INSERT: "INSERT",
  UPDATE: "UPDATE",
  REPLACE: "REPLACE",
  DELETE: "DELETE",
  MERGE: "MERGE"
};
var useOperationSubscription = function useOperationSubscription(GRAPHQL_SUBSCRIPTION, userOptions) {
  var _dataOptions$debug;
  var dataOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var __nameDeprecated = arguments.length > 3 ? arguments[3] : undefined;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  // https://github.com/apollographql/apollo-client/blob/d96f4578f89b933c281bb775a39503f6cdb59ee8/src/core/networkStatus.ts#L4
  var _useState3 = (0, _react.useState)(_client.NetworkStatus.loading),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    networkStatus = _useState4[0],
    setNetworkStatus = _useState4[1];
  // If immediately after the subscription is remade due to changing options, a
  // new re-render happens (due to a setState like the one in the useEffect
  // below), then the "useSubscription" hook will return its latest event. If
  // that event is a `READY` operation, that will mistakenly trigger our second
  // useEffect from below which sets "loading" to "false" before any new data is
  // retrieved. A proper fix would be for "useSubscription" not to return an old
  // event on re-render if the stream has been remade, but that needs to happen
  // in @apollo/client. We are mitigating this issue by using a "readyRef" to
  // track the latest "READY" operation that triggered a "loading" state set to "false".
  var readyRef = (0, _react.useRef)();

  // Use the subscription name for debugging
  var graphqlConsole = (0, _jsTools.getGraphqlConsole)((_dataOptions$debug = dataOptions.debug) !== null && _dataOptions$debug !== void 0 ? _dataOptions$debug : false);
  var subName = GRAPHQL_SUBSCRIPTION.definitions[0].selectionSet.selections[0].name.value;
  (0, _react.useEffect)(function () {
    if (!__nameDeprecated) {
      return;
    }
    console.warn("DEPRECATED: The \"useOperationSubscription(".concat(subName, ")\" 4th argument is deprecated. Please pass the \"name\" as a property of the 3rd argument instead. E.g. useOperationSubscription(GRAPHQL_SUBSCRIPTION, userOptions, { name: \"MySubscriptionName\" }) instead of useOperationSubscription(GRAPHQL_SUBSCRIPTION, userOptions, \"MySubscriptionName\")\nThe deprecated API will be removed in August 2024."));
  }, [__nameDeprecated, subName]);

  // Debounce the setData calls to avoid multiple re-renders for batches of updates of rapid succession
  var _useDebouncedOperatio = (0, _useDebouncedOperation["default"])({
      setData: (0, _react.useCallback)(function (newData) {
        var _readyRef$current;
        if (((_readyRef$current = readyRef.current) === null || _readyRef$current === void 0 ? void 0 : _readyRef$current.operationType) !== operationTypes.READY) {
          return;
        }
        setData(newData);
      }, []),
      name: dataOptions.name || __nameDeprecated,
      debounceMs: 300,
      maxDebounceMs: 3000,
      onFlush: dataOptions.onFlush,
      dependencies: [userOptions === null || userOptions === void 0 ? void 0 : userOptions.skip, userOptions === null || userOptions === void 0 ? void 0 : userOptions.variables]
    }, dataOptions.debug),
    _useDebouncedOperatio2 = (0, _slicedToArray2["default"])(_useDebouncedOperatio, 2),
    pushToQueue = _useDebouncedOperatio2[0],
    _useDebouncedOperatio3 = _useDebouncedOperatio2[1],
    resetQueue = _useDebouncedOperatio3.resetQueue,
    isFlushingQueue = _useDebouncedOperatio3.isFlushingQueue,
    flush = _useDebouncedOperatio3.flush;
  var options = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, userOptions), {}, {
      // shouldResubscribe: true,
      // Persisting events using "onData" due to an issue with how subscription
      // events with the same timestamp are dealt with by React 18's automatic
      // batching.
      // - Discussion with the apollo team:
      // https://github.com/apollographql/apollo-client/issues/10001#issuecomment-1636413985
      // - Recommendation PR:
      // https://github.com/apollographql/apollo-client/pull/11072/files
      // - Apollo docs (to be updated after docs are deployed in prod):
      // https://deploy-preview-11072--apollo-client-docs.netlify.app/api/react/hooks/#subscriptions-and-react-18-automatic-batching
      onData: function onData(_ref) {
        var data = _ref.data.data;
        var operation = data === null || data === void 0 ? void 0 : data[Object.keys(data)[0]];
        // Assumes only one other field besides the operationType field.
        var rawOperationEntities = operation === null || operation === void 0 ? void 0 : operation[(0, _findKey["default"])(operation, function (_, fieldName) {
          return fieldName !== "operationType";
        })];
        // Some subscriptions use multiple layers of nesting
        // if the data is nested, we need to unpack it
        // E.g. unpackData for MDM Resources Subscription is data => data.mdmResource.callsign
        var operationEntities = dataOptions.unpackData ? rawOperationEntities === null || rawOperationEntities === void 0 ? void 0 : rawOperationEntities.map(dataOptions.unpackData) : rawOperationEntities;
        graphqlConsole.log("".concat(subName, ": New useSubscription event:"), {
          operation: operation,
          operationEntities: operationEntities
        });

        // Ensure we always receive a list of entities to process, even for single items
        if (operationEntities && !(0, _isArray["default"])(operationEntities)) {
          console.error("Please provide an array of entities for useOperationSubscription", GRAPHQL_SUBSCRIPTION, operation);
        }
        switch (operation === null || operation === void 0 ? void 0 : operation.operationType) {
          case operationTypes.READY:
            // Stop loading and persist data in state when a new READY operation
            // has been emitted.
            graphqlConsole.log("".concat(subName, ": Attempting to add READY to queue"));
            pushToQueue(function ready(currentState) {
              graphqlConsole.log("".concat(subName, ": Executing READY job from queue:"), {
                currentState: currentState
              });
              setNetworkStatus(_client.NetworkStatus.ready);
              readyRef.current = operation;
            }, true);
            flush();
            break;
          case operationTypes.INSERT:
            graphqlConsole.log("".concat(subName, ": Adding INSERT to queue"));
            pushToQueue(function insertInCache(currentState, setNextState) {
              // Omitting inserts of already inserted entities
              var newEntities = (0, _differenceBy["default"])(operationEntities, currentState, "id");
              graphqlConsole.log("".concat(subName, ": Executing INSERT job from queue"), {
                newEntities: newEntities
              });
              if ((newEntities === null || newEntities === void 0 ? void 0 : newEntities.length) > 0) {
                setNextState([].concat((0, _toConsumableArray2["default"])(currentState), (0, _toConsumableArray2["default"])(newEntities)));
              }
            });
            break;
          case operationTypes.UPDATE:
          case operationTypes.REPLACE:
            graphqlConsole.log("Attempting to add ".concat(operation.operationType, " to queue"));
            pushToQueue(function replaceInCache(_, setNextState) {
              if ((operationEntities === null || operationEntities === void 0 ? void 0 : operationEntities.length) > 0) {
                setNextState(function (currentData) {
                  (0, _forEach["default"])(operationEntities, function (changedEntity) {
                    var index = (0, _findIndex["default"])(currentData, {
                      id: changedEntity.id
                    });
                    if (index < 0) {
                      return;
                    }
                    currentData[index] = changedEntity;
                  });
                  graphqlConsole.log("".concat(subName, ": Executing ").concat(operation.operationType, " job from queue"));
                  return currentData;
                });
              }
            });
            break;
          case operationTypes.DELETE:
            graphqlConsole.log("".concat(subName, ": Adding DELETE to queue"));
            pushToQueue(function deleteFromCache(currentState, setNextState) {
              var remainingEntities = (0, _differenceBy["default"])(currentState, operationEntities, "id");
              if (remainingEntities.length !== currentState.length) {
                graphqlConsole.log("".concat(subName, ": DELETING"), {
                  stateBeforeDelete: currentState,
                  stateAfterDelete: remainingEntities
                });
                setNextState(remainingEntities);
              }
            });
            break;
          default:
            console.error("Unknown useOperationSubscription operationType", operation === null || operation === void 0 ? void 0 : operation.operationType);
            break;
        }
      }
    });
  }, [userOptions, dataOptions.unpackData, graphqlConsole, subName, GRAPHQL_SUBSCRIPTION, pushToQueue, flush]);
  var subscription = (0, _client.useSubscription)(GRAPHQL_SUBSCRIPTION, options);

  // Reset internal state when the subscription is remade. The queue resetting
  // is done in useDebouncedOperation.
  (0, _react.useEffect)(function () {
    if (!subscription.loading) {
      return;
    }
    setData(function (data) {
      return (0, _isEmpty["default"])(data) ? data : [];
    });
    setNetworkStatus(_client.NetworkStatus.loading);
  }, [pushToQueue, resetQueue, subscription.loading]);
  var updateCache = (0, _react.useCallback)(function (_ref2) {
    var data = _ref2.data,
      operationType = _ref2.operationType;
    if (!Array.isArray(data)) {
      console.error("The first argument to \"updateCache\" needs to be an array. You sent \"".concat(JSON.stringify(data), "\""));
    }
    switch (operationType) {
      case operationTypes.INSERT:
        setData(function (currentState) {
          // Omitting inserts of already inserted entities
          var newEntities = (0, _differenceBy["default"])(currentState, data, "id");
          if ((newEntities === null || newEntities === void 0 ? void 0 : newEntities.length) > 0) {
            return [].concat((0, _toConsumableArray2["default"])(currentState), (0, _toConsumableArray2["default"])(newEntities));
          }
        });
        break;
      case operationTypes.UPDATE:
      case operationTypes.REPLACE:
        setData(function (currentState) {
          (0, _forEach["default"])(data, function (changedEntity) {
            var index = (0, _findIndex["default"])(currentState, {
              id: changedEntity === null || changedEntity === void 0 ? void 0 : changedEntity.id
            });
            currentState[index] = changedEntity;
          });
          return currentState;
        });
        break;
      case operationTypes.DELETE:
        setData(function (currentState) {
          var remainingEntities = (0, _differenceBy["default"])(currentState, data, "id");
          return remainingEntities.length !== currentState.length ? remainingEntities : currentState;
        });
        break;
      case operationTypes.MERGE:
        setData(function (currentState) {
          var clonedCurrentState = (0, _cloneDeep["default"])(currentState);
          clonedCurrentState.map(function (entity) {
            var update = data.find(function (d) {
              return d.id === entity.id;
            });
            return update ? (0, _merge["default"])(entity, update) : entity;
          });
          return clonedCurrentState;
        });
        break;
      default:
        console.error("Unknown \"".concat(operationType, "\" operationType sent to \"updateCache\"."));
    }
  }, []);
  if (subscription.error) {
    setNetworkStatus(_client.NetworkStatus.error);
    console.error("Error in useOperationSubscription subscription \"".concat(GRAPHQL_SUBSCRIPTION.definitions.filter(function (d) {
      return d.kind === "OperationDefinition";
    }).map(function (d) {
      var _d$name;
      return (_d$name = d.name) === null || _d$name === void 0 ? void 0 : _d$name.value;
    }).join(","), "\""), subscription.error);
  }
  return _objectSpread(_objectSpread({}, subscription), {}, {
    data: data,
    networkStatus: networkStatus,
    updateCache: updateCache,
    loading: networkStatus === _client.NetworkStatus.loading,
    isFlushingQueue: isFlushingQueue
  });
};
var _default = exports["default"] = useOperationSubscription;